/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-cycle */
import React, { FC } from 'react';
import Link from 'next/link';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Block } from '@contentful/rich-text-types';
import clsx from 'clsx';
import Button from '../Button';
import { CType } from '../../models/Contentful/types';
import { ISkillbuilderProps } from '../../models/SkillBuilder/@types';
import ImageComponent from '../Image';
import SectionWrapper from '../SectionWrapper';
import Typo from '../Typo';
import styles from './skillbuilder.module.sass';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';

const SkillbuilderCard: FC<ISkillbuilderProps> = props => {
  const { isMobile } = useIsMobileViewport();
  const {
    title,
    description,
    // image,
    skillIcon,
    skills,
    industryList,
    award,
    earnPoints,
    duration,
    partners,
    slug,
    status,
    internship,
  } = props;
  const industry = industryList?.fields?.title?.join(', ');
  const skillNames = skills?.fields?.title ?? [];
  const descriptionText = documentToPlainTextString(description as unknown as Block);

  const withLink = (child: React.ReactNode, classes?: string) => (
    <Link href={`/skillbuilders/${slug}`} className={classes}>
      {child}
    </Link>
  );
  if (internship) {
    return (
      <div>
        <div className={styles.cardRootHorizontal}>
          <div className="is-flex is-flex-direction-column">
            <div className={`p-2 ${styles.gridSkillbuilder}`}>
              <div className={styles.topSectionInternship}>
                {!isMobile && (
                  <div
                    className={`${styles.topSectionText} is-flex is-flex-direction-column mt-1 purp`}
                  >
                    <Typo small>{industry}</Typo>
                    <Typo small>{skillNames[0]}</Typo>
                  </div>
                )}
                <div>
                  <ImageComponent
                    image={skillIcon}
                    classes={styles.topImage}
                    width={isMobile ? '60px' : '130px'}
                    height={isMobile ? '60px' : '130px'}
                  />
                  <Typo small classes={`${styles.effort} is-color-BlackHalf`}>
                    Effort: {duration}
                  </Typo>
                  {partners?.length > 0 ? (
                    isMobile ? (
                      <div className="is-flex is-flex-direction-column is-align-items-left">
                        <ImageComponent
                          classes={styles.partnerLogo}
                          image={partners[0].fields.image}
                        />
                        <div
                          className={`${styles.topSectionText} is-flex is-flex-direction-column mt-1 purp`}
                        >
                          <Typo small>{industry}</Typo>
                          <Typo small>{skillNames[0]}</Typo>
                        </div>
                      </div>
                    ) : (
                      <ImageComponent
                        classes={styles.partnerLogo}
                        image={partners[0].fields.image}
                        height="37px"
                      />
                    )
                  ) : null}
                  <div className="is-flex is-justify-content-center">
                    <Typo normal classes={styles.pointsGrid}>
                      Earns: <br />
                      {earnPoints} points
                    </Typo>
                    {award && (
                      <Typo normal classes={styles.pointsGrid}>
                        Awarded: <br />
                        {award}
                      </Typo>
                    )}
                  </div>
                </div>
              </div>
              <div className="is-flex is-flex-direction-column">
                {withLink(
                  <Typo h3 limitLines={1} classes={`${styles.title}`}>
                    {title}
                  </Typo>,
                )}
                {descriptionText && (
                  <>
                    <Typo normal limitLines={2} classes={`${styles.lineClamp} is-color-Black`}>
                      {descriptionText}
                    </Typo>
                    {withLink(
                      <Typo normal classes="is-color-Blue">
                        {` More`}
                      </Typo>,
                    )}
                  </>
                )}

                <div
                  className={`p-2 is-flex is-justify-content-center ${styles.buttonHolderInternship}`}
                >
                  {withLink(
                    <Button
                      theme="Filled - Lime Green Gradient"
                      disabled={status === 'completed'}
                      classes={styles.button}
                    >
                      {status === 'completed' ? 'Completed' : 'Do It!'}
                    </Button>,
                    styles.buttonLink,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className={styles.cardRoot}>
        <div className="is-flex is-flex-direction-column">
          <div className="p-5">
            <div className={styles.topSection}>
              {!isMobile && (
                <div
                  className={`${styles.topSectionText} is-flex is-flex-direction-column mt-1 purp`}
                >
                  <Typo small>{industry}</Typo>
                  <Typo small>{skillNames[0]}</Typo>
                </div>
              )}
              <ImageComponent
                image={skillIcon}
                classes={styles.topImage}
                width={isMobile ? '60px' : '130px'}
                height={isMobile ? '60px' : '130px'}
              />
              {partners?.length > 0 ? (
                isMobile ? (
                  <div className="is-flex is-flex-direction-column is-align-items-left">
                    <ImageComponent classes={styles.partnerLogo} image={partners[0].fields.image} />
                    <div
                      className={`${styles.topSectionText} is-flex is-flex-direction-column mt-1 purp`}
                    >
                      <Typo small>{industry}</Typo>
                      <Typo small>{skillNames[0]}</Typo>
                    </div>
                  </div>
                ) : (
                  <ImageComponent
                    classes={styles.partnerLogo}
                    image={partners[0].fields.image}
                    height="37px"
                  />
                )
              ) : null}
            </div>
            {withLink(
              <Typo h3 limitLines={1} classes={`${styles.title}`}>
                {title}
              </Typo>,
            )}
            <Typo small classes={`${styles.effort} is-color-BlackHalf`}>
              Effort: {duration}
            </Typo>
            {descriptionText && (
              <>
                <Typo
                  normal
                  limitLines={2}
                  classes={`${styles.lineClamp} is-color-Black ${styles.description}`}
                >
                  {descriptionText}
                </Typo>
                {withLink(
                  <Typo normal classes="is-color-Blue">
                    {` More`}
                  </Typo>,
                )}
              </>
            )}
          </div>
          <div className="is-flex is-justify-content-center">
            <Typo normal classes={styles.pointsGrid}>
              Earns: <br />
              {earnPoints} points
            </Typo>
            {award && (
              <Typo normal classes={styles.pointsGrid}>
                Awarded: <br />
                {award}
              </Typo>
            )}
          </div>
          <div className="p-5 is-flex is-justify-content-center">
            {withLink(
              <Button
                theme="Filled - Dark Blue"
                disabled={status === 'completed'}
                classes={styles.button}
              >
                {status === 'completed' ? 'Completed' : 'Do It!'}
              </Button>,
              styles.buttonLink,
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Skillbuilder: FC<CType<ISkillbuilderProps>> = props => {
  const { fields } = props;
  const { internship } = fields;
  return (
    <SectionWrapper
      hasBodyMargin={false}
      classes={clsx(styles.root, { [styles.rootInternship]: internship })}
    >
      <SkillbuilderCard {...fields} internship={internship} />
    </SectionWrapper>
  );
};

export default Skillbuilder;
